
import { Component, input } from '@angular/core';
import { Variable } from '@apis/cas/generated';

@Component({
  selector: 'app-debug-variables',
  imports: [],
  templateUrl: './debug-variables.component.html',
  styleUrl: './debug-variables.component.css',
})
export class DebugVariablesComponent {
  entries = input.required<{ variable: Variable; value: string | undefined }[]>();
}
